<div class="brand-logo-wrapper">
  <div class="logo">
    <img [src]="icon.logo" alt="" srcset="" />
  </div>
</div>
